<template>
  <el-row v-if="!notFound" class="container">
    <el-col :span="24">
      <el-row :gutter="30">
        <el-col :xs="24" :sm="24" :md="7" :lg="5">
          <h3 class="topTitle">Información Conductor</h3>
          <el-row>
            <el-col :span="24">
              <div
                v-for="(value, key) in informacionChofer"
                v-bind:key="key"
                class = "box-info-style">
                <div class= "value-style">
                  {{ value }}
                </div>
                <div class = "key-style">
                  {{ key.toUpperCase() }}
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="17" :lg="19">
          <h3 class="topTitle">Información puntos de entrega</h3>
          <el-row>
            <el-col :span="24" justify="end">
              <div class="table smallerTag smallerTable" v-if="show">
                <DriverTable
                  :tableData="routesOrdenadas"
                  @infoWindowPoint="handdleInfoWindow"
                  @clickOnClient="handleSeeMore"/>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider><i class="fas fa-map-marked-alt"></i> Visualización de la ruta</el-divider>
      <el-row>
        <div class="map-box">
          <MapRoutes
            slot="map"
            :locations="routes"
            :height="'500px'"
            :infoWindowPoint="infoWindowsPoint"
            @infoWindowPoint="handdleInfoWindow"
            :scrollWheel="false"></MapRoutes>
        </div>
      </el-row>
    </el-col>
  </el-row>
  <el-row v-else>
    <el-col>
      <notFound
        imgName="fb-patent.svg"
        :textGreen="'No se encontró'"
        :textGrey="'el nº de patente'" />
    </el-col>
  </el-row>
</template>

<script>
import { decodeRSA } from '../../mixins/function';
import MapRoutes from './maps/MapRoutesHanddleInfoWindow.vue';
import Search from './TracingSearch.vue';
import NotFound from './Base404.vue';
import DriverTable from './TracingDriverTable.vue';

export default {
  props: {
    dataDriver: {
      type: Object,
    },
    notFound: {
      type: Boolean,
    },
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    search: Search,
    MapRoutes,
    notFound: NotFound,
    DriverTable,
  },
  filters: {
    applyDecodeRSA(data) {
      return decodeRSA(data);
    },
  },
  data() {
    return {
      reloadMap: false,
      firstLoad: false,
      show: true,
      informacionCliente: {
        nombre: '',
        telefono: '',
        eta: '',
        direccion: '',
      },
      route: null,
      searchActive: 0,
      typeSearch: 1,
      dataSearch: {},
      typeResult: '',
      routes: [],
      routesTable: [],
      charge: true,
      informacionChofer: {
        nombre: '',
        telefono: '',
        empresa: '',
        patente: '',
        id: '',
      },
      points: {
        data: [],
      },
      paquetes: [],
      informacionPaquete: {
        orden: '',
        estado: '',
        f12: '',
      },
      items: {
        item1: 'item1',
        item2: 'item2',
      },
      paquetearray: [],
      routesOrdenadas: null,
      infoWindowsPoint: 0,
    };
  },
  methods: {
    close() {
      this.$emit('restart', 0);
    },
    handdleInfoWindow(point) {
      this.infoWindowsPoint = point + 1;
    },
    initialLoad() {
      // información del mapa
      this.routes = this.dataDriver;
      this.routesTable = this.dataDriver;
      this.routesOrdenadas = this.dataDriver.delivery_points;
      this.routesOrdenadas = this.routesOrdenadas.sort((a, b) => this.routePosition(a, b));
      this.charge = true;
      // informacion del chofer
      this.informacionChofer.nombre = `${decodeRSA(this.dataDriver.driver.first_name)} ${decodeRSA(this.dataDriver.driver.last_name)}`;
      this.informacionChofer.telefono = this.dataDriver.vehicle.phone;
      this.informacionChofer.patente = this.dataDriver.vehicle.patent;
      this.informacionChofer.empresa = this.dataDriver.driver.enterprise.name;
      this.informacionChofer.id = this.dataDriver.id;
    },
    routePosition(a, b) {
      if (b.route_position === null && a.route_position !== null) {
        return -1;
      } if (a.route_position === null && b.route_position !== null) {
        return 1;
      } if (a.route_position > b.route_position) {
        return 1;
      } if (b.route_position > a.route_position) {
        return -1;
      } if (b.route_position === null && a.route_position === null) {
        return 0;
      }
      return 0;
    },
    abrirInfo() {
      // información del mapa
      this.routesTable = this.dataDriver;
      this.routesOrdenadas = this.dataDriver[0].delivery_points;
      this.routesOrdenadas = this.routesOrdenadas.sort((a, b) => this.routePosition(a, b));
      // informacion del chofer
      this.informacionChofer.nombre = `${decodeRSA(this.dataDriver[0].driver.first_name)} ${decodeRSA(this.dataDriver[0].driver.last_name)}`;
      this.informacionChofer.telefono = this.dataDriver[0].vehicle.phone;
      this.informacionChofer.patente = this.dataDriver[0].vehicle.patent;
      this.informacionChofer.empresa = this.dataDriver[0].driver.enterprise.name;
      this.informacionChofer.id = this.dataDriver[0].id;
    },
    handleSeeMore(el) {
      this.$emit('clickOnClient', el);
    },
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  },
  watch: {
    dataDriver(newEl, oldEl) {
      if (this.charge) {
        this.abrirInfo();
        this.show = false;
        this.$nextTick(() => {
          this.show = true;
        });
      }
      if (this.charge && newEl.id !== oldEl.id) {
        this.initialLoad();
      }
      this.firstLoad = true;
    },
    firstLoad() {
      this.initialLoad();
    },
  },
};
</script>

<style scoped>
  .map-box {
    margin-top: 1em;
  }
  .container {
    box-sizing: border-box;
    overflow: hidden;
  }
  .topTitle {
    text-transform: uppercase;
    font-size: 16px;
    text-align: left;
    margin: 0 0 5px;
  }
  .value-style {
    font-weight: 300;
    font-size: 18px;
  }
  .key-style {
    font-weight: 700;
    font-size: 10px;
    color: #AAD500;
    margin-bottom: 1em;
  }
  .box-info-style {
    text-align: left;
  }
  .home-boton i {
    font-size: 50px;
    color: #AAD500;
    margin-top: 5%;
    cursor: pointer;
  }
  .linkStyle{
    color: #AAD500;
    border: none;
    font-weight: 600;
    font-size: 15px;
    outline: none;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.0);
    margin: 0;
    padding: 0;
  }
  .dotStyle {
    color: #AAD500;
  }
  @media only screen and (max-width: 768px) {
    .container {
      width: 100vw;
    }
  }
</style>
